import type { Widget } from '@neptune/shared/widgets-domain';
import {
  DynamicSectionWidget,
  isDynamicSectionWidget,
} from '@neptune/widgets/dynamic-section-domain';

import { ChartWidget, ChartWidgetOptions, isChartWidget } from './chart-widget';

export function getChartOptionsFromChartWidget(widget: ChartWidget): ChartWidgetOptions {
  return widget.options;
}

export function setChartOptionsInChartWidget<TWidget extends ChartWidget>(
  widget: TWidget,
  options: ChartWidgetOptions,
): TWidget {
  return { ...widget, options };
}

export function getChartOptionsFromWidget<TWidget extends Widget>(
  widget: TWidget,
): ChartWidgetOptions | undefined {
  if (isChartWidget(widget)) {
    return getChartOptionsFromChartWidget(widget);
  }

  if (isDynamicSectionWidget(widget)) {
    return widget.options.chartOptions;
  }
}

export function setChartOptionsInWidget<TWidget extends Widget>(
  widget: TWidget,
  options: ChartWidgetOptions,
): TWidget {
  if (isChartWidget(widget)) {
    return setChartOptionsInChartWidget(widget, options);
  }

  if (isDynamicSectionWidget(widget)) {
    return {
      ...widget,
      options: { ...widget.options, chartOptions: options },
    } satisfies DynamicSectionWidget;
  }

  return widget;
}
